// Registry of simulator packs, keyed by URL id. Every `*.js` pack in this
// folder is picked up automatically; run `node src/pages/Simulator/packs/validate.mjs`
// before shipping a new one. Order here is the order on the hub page.
const modules = import.meta.glob(['./*.js', '!./index.js'], { eager: true });

const ORDER = [
  'project-manager',
  'recruiter',
  'sales-manager',
  'marketing-manager',
  'data-analyst',
  'qa-engineer',
  'customer-support',
  'accountant',
  'nurse',
  'teacher'
];

const loaded = Object.values(modules)
  .map((m) => m.default)
  .filter((p) => p && p.id && Array.isArray(p.steps));

const byId = Object.fromEntries(loaded.map((p) => [p.id, p]));

const packs = {};
ORDER.forEach((id) => {
  if (byId[id]) packs[id] = byId[id];
});
loaded.forEach((p) => {
  if (!packs[p.id]) packs[p.id] = p;
});

export default packs;
